import { LoadingSpinner } from './LoadingSpinner';

interface CenteredLoadingSpinnerProps {
  message?: string;
}

export const CenteredLoadingSpinner = (props: CenteredLoadingSpinnerProps) => {
  return (
    <div
      data-testid="container"
      style={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      <LoadingSpinner />
      {props.message && <div style={{ fontSize: '0.75rem', margin: '0.25rem 0 0 0' }}>{props.message}</div>}
    </div>
  );
};
